import type { Template } from "@/redux/reducer/pages.api";
import type { CustomerDomain } from "@/redux/reducer/customers.api";
import { getPublicLinkBase } from "../../shared/publicLinkBase";

export type JobAdTemplateOption = {
  value: string;
  label: string;
  careerSites: string[];
};

export const jobAdTemplateOptions = (
  templates: Template[],
  domains: CustomerDomain[]
): JobAdTemplateOption[] =>
  templates
    .filter((template) => template.published)
    .map((template) => ({
      value: template.id,
      label: template.name,
      careerSites: domains
        .filter((domain) =>
          domain.joblist_page?.job_ad_pages.some(
            (page) => page.job_ad_page_id === template.id
          )
        )
        .map((domain) =>
          getPublicLinkBase(domain).replace(/^https?:\/\//i, "")
        ),
    }))
    .filter((option) => option.careerSites.length > 0);
